<template>
  <div class="create-button">
    <slot :on="init" :loading="loading">
      <v-btn @click.stop="init" rounded depressed color="primary">
        {{ $t("Créer une société") }}
      </v-btn>
    </slot>
  </div>
</template>

<script>
import CreateButton from "@/components/functional/CreateButton";
import { createNamespacedHelpers } from "vuex";
import { RESET, POPULATE_ONE, FETCH } from "@/store/action-types";
import { mapCompanyCreateFormFields } from "@/store/modules/company";
import { mapAppFields } from "@/store/modules/app";

const { mapActions: mapCompanyActions } = createNamespacedHelpers(`company`);
const { mapActions: mapApplicationActions } = createNamespacedHelpers(
  `application`
);

const { mapActions: mapCompanyCreateFormActions } = createNamespacedHelpers(
  `company/createForm`
);

export default {
  extends: CreateButton,
  computed: {
    ...mapCompanyCreateFormFields({
      formEntity: "entity"
    }),
    ...mapAppFields(["isCompanyDrawerOpen"])
  },
  methods: {
    async openDrawer() {
      this.$gtm.trackEvent({
        event: "interaction",
        category: "company",
        action: `Click (Ouverture du panel société (${
          this.entity ? "société existante" : "nouvelle société"
        })`
      });
      await this.getApplications();
      this.isCompanyDrawerOpen = true;
    },
    ...mapCompanyActions({
      populateCompanyEntity: POPULATE_ONE
    }),
    ...mapApplicationActions({
      getApplications: FETCH
    }),
    async populateEntity(id) {
      await this.populateCompanyEntity(id);
    },
    ...mapCompanyCreateFormActions({
      resetForm: RESET
    })
  }
};
</script>
